import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const myTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'အမည် (အသေး၊ အထူးအက္ခရာများမပါ)',
    add: 'ထည့်ပါ။',
    allowedFileTypes: 'ခွင့်ပြုထားသော ဖိုင်အမျိုးအစားများ',
    allowedFileTypesDescription:
      'ခွင့်ပြုထားသော ဖိုင်အမျိုးအစားများ (ဥပမာ၊ image/*၊ application/pdf) ကို ကန့်သတ်ပါ။ အမျိုးအစားအားလုံးကို ခွင့်ပြုရန် ဗလာချန်ထားပါ။',
    allowMultipleFiles: 'ဖိုင်များစွာကို ခွင့်ပြုပါ။',
    amountInCents: 'ပမာဏ ဆင့်',
    basePrice: 'အခြေခံဈေး',
    bcc: 'BCC',
    brand: 'အမှတ်တံဆိပ်',
    cc: 'CC',
    checkboxPlural: 'အကွက်များကို အမှတ်ခြစ်ပါ။',
    checkboxSingular: 'အမှန်ခြစ်ပါ။',
    checkedByDefault: 'မူရင်းအတိုင်း စစ်ဆေးထားသည်။',
    chooseConfirmationType:
      'ဖောင်တင်ပြီးနောက် စာမျက်နှာပေါ်ရှိ မက်ဆေ့ချ်ကို ပြသရန် သို့မဟုတ် အခြားစာမျက်နှာသို့ ပြန်ညွှန်းရန် ရွေးချယ်ပါ။',
    condition: 'အခြေအနေ',
    confirmationMessage: 'အတည်ပြုချက် Message',
    confirmationType: 'အတည်ပြုချက်အမျိုးအစား',
    countryPlural: 'လယ်ကွင်းများ',
    countrySingular: 'တိုင်းပြည်',
    creditCard: 'အကြွေးဝယ်ကတ်',
    customURL: 'စိတ်ကြိုက် URL',
    datePlural: 'ရက်စွဲအကွက်များ',
    dateSingular: 'ရက်စွဲ',
    defaultValue: 'မူရင်းတန်ဖိုး',
    divide: 'ဝေ',
    documentToLinkTo: 'လင့်ခ်ချိတ်ရန် စာရွက်စာတမ်း',
    doesNotEqual: 'မညီမျှပါ။',
    emailFrom: 'Email From',
    emailPlural: 'အီးမေးလ်အကွက်များ',
    emailsDescription:
      'ဖောင်တင်သည့်အခါ စိတ်ကြိုက်အီးမေးလ်များ ပေးပို့ပါ။ တူညီသောအီးမေးလ်ကို လက်ခံသူအများအပြားထံ ပေးပို့ရန် ကော်မာခွဲထားသောစာရင်းများကို အသုံးပြုပါ။ ဤဖောင်မှ တန်ဖိုးတစ်ခုကို ကိုးကားရန်၊ ထိုအကွက်၏ အမည်ကို နှစ်ချက်ကောက်ကောက် ကွင်းပိတ်ဖြင့် ပတ်ပါ၊ ဥပမာ {{firstName}}။ ဒေတာအားလုံးကို ထုတ်ပေးရန် {{*}} ကို အသုံးပြုနိုင်ပြီး အီးမေးလ်ထဲတွင် HTML ဇယားအဖြစ် ဖော်မတ်ရန် {{*:table}} ကို အသုံးပြုနိုင်သည်။',
    emailSingular: 'အီးမေးလ်',
    emailTo: 'ထံသို့ အီးမေးလ်ပို့ပါ။',
    equals: 'ညီမျှသည်။',
    field: 'လယ်ကွင်း',
    fields: 'လယ်ကွင်းများ',
    fieldWidth: 'အကွက်အကျယ် (ရာခိုင်နှုန်း)',
    hasAnyValue: 'တန်ဘိုးတစ်ခုခု ရှိတယ်။',
    internalLink: 'အတွင်းပိုင်းလင့်ခ်',
    label: 'တံဆိပ်',
    maxFileSize: 'အများဆုံး ဖိုင်အရွယ်အစား (ဘိုက်များ)',
    maxFileSizeDescription: 'အများဆုံးဖိုင်အရွယ်အစားကို bytes အကန့်အသတ်မရှိ အလွတ်ထားခဲ့ပါ။',
    message: 'စာတို',
    messageDescription: 'ဤအီးမေးလ်တွင် ပေးပို့သင့်သော မက်ဆေ့ချ်ကို ထည့်သွင်းပါ။',
    messagePlural: 'မက်ဆေ့ချ်များ',
    messageSingular: 'စာတို',
    mimeType: 'MIME အမျိုးအစား',
    mimeTypePlural: 'MIME အမျိုးအစားများ',
    mimeTypeSingular: 'MIME အမျိုးအစား',
    multiply: 'များပြားသည်။',
    numberPlural: 'နံပါတ်ကွက်များ',
    numberSingular: 'နံပါတ်',
    optionPlural: 'ရွေးချယ်စရာများ',
    optionSingular: 'ရွေးချယ်မှု',
    paymentFieldPlural: 'ငွေပေးချေမှုနယ်ပယ်များ',
    paymentFieldSingular: 'ငွေပေးချေမှု',
    paymentProcessor: 'ငွေပေးချေမှု ပရိုဆက်ဆာ',
    paymentStatus: 'အဆင့်အတန်း',
    placeholder: 'နေရာယူသည်။',
    priceConditions: 'စျေးနှုန်းအခြေအနေများ',
    priceConditionsPlural: 'စျေးနှုန်းအခြေအနေများ',
    priceConditionsSingular: 'ဈေးနှုန်းအခြေအနေ',
    radioOptions: 'ရေဒီယို ရည်ညွှန်းချက် ရွေးချယ်မှုများ',
    radioPlural: 'ရေဒီယို နယ်ပယ်များ',
    radioSingular: 'ရေဒီယို',
    redirect: 'ပြန်ညွှန်းသည်။',
    replyTo: 'အကြောင်းပြန်ပါ။',
    required: 'လိုအပ်သည်။',
    selectOptions: 'ရွေးချယ်စရာများကို ရွေးပါ။',
    selectPlural: 'Fields ကို ရွေးပါ။',
    selectSingular: 'ရွေးချယ်ပါ။',
    statePlural: 'ပြည်နယ်လယ်ကွင်းများ',
    stateSingular: 'ပြည်နယ်',
    staticValue: 'Static Value',
    subject: 'ဘာသာရပ်',
    submitButton: 'ခလုတ်တံဆိပ်ကို တင်သွင်းပါ။',
    subtract: 'နုတ်',
    textareaPlural: 'Textarea နယ်ပယ်များ',
    textareaSingular: 'Textarea',
    textPlural: 'စာသားအကွက်များ',
    textSingular: 'စာသား',
    title: 'ခေါင်းစဉ်',
    token: 'တိုကင်',
    uploadCollection: 'စုစည်းမှုတင်ပါ။',
    uploadCollectionDescription: 'ဖိုင်များသိမ်းဆည်းရန် မည်သည့်အပ်လုဒ်စုဆောင်းမှုကို ရွေးချယ်ပါ။',
    uploadFieldPlural: 'အကွက်များကို အပ်လုဒ်လုပ်ပါ။',
    uploadFieldSingular: 'တင်သည်။',
    urlToRedirectTo: 'ပြန်ညွှန်းရန် URL',
    value: 'တန်ဖိုး',
    valueOfField: 'နယ်ပယ်တန်ဖိုး',
    valueType: 'တန်ဖိုးအမျိုးအစား',
  },
}

export const my: PluginLanguage = {
  dateFNSKey: 'en-US',
  translations: myTranslations,
}
